import { AnchorModel, Link } from '@bpba/ui-components';

export class SelloData extends AnchorModel {
  imagenUrl?: string;
  textoAlternativo?: string;

  constructor(orden?: number, enlace?: Link, mensaje?: string, imagenUrl?: string, textoAlternativo?: string) {
    super(orden, undefined, enlace, mensaje);
    this.imagenUrl = imagenUrl;
    this.textoAlternativo = textoAlternativo;
  }
}
